import { dispatchClient } from '../clients';
import {
  ApiResponseWithPaging,
  TaskGroup,
  TaskGroupsListFilter,
} from '@dispatch/shared/types';
import { mapResponseWithPaging } from '../helpers/AxiosMappers';

const APIM_SERVICE_TASK_GROUPS_URL = 'dispatch/service/taskgroups';

export async function getTaskGroups(pageSize?: number) {
  const params = pageSize
    ? new URLSearchParams([['pageSize', pageSize?.toString()]])
    : null;
  const response = await dispatchClient.get<TaskGroup[]>(
    `${APIM_SERVICE_TASK_GROUPS_URL}`,
    {
      params,
    }
  );

  return response.data;
}

export async function getTaskGroupsPaginated(
  filters: TaskGroupsListFilter,
  continuationToken?: string
): Promise<ApiResponseWithPaging<TaskGroup[]>> {
  const response = await dispatchClient.get<TaskGroup[]>(
    `${APIM_SERVICE_TASK_GROUPS_URL}`,
    {
      params: {
        ...filters,
      },
      headers: {
        'Continuation-Token': continuationToken || '',
      },
    }
  );

  return mapResponseWithPaging(response);
}

export async function getTaskGroup(taskGroupId: string) {
  return dispatchClient.get<TaskGroup>(
    `${APIM_SERVICE_TASK_GROUPS_URL}/${taskGroupId}`
  );
}

export async function upsertTaskGroup(postData: Partial<TaskGroup>) {
  return dispatchClient.put<TaskGroup>(
    `${APIM_SERVICE_TASK_GROUPS_URL}/${postData.id}`,
    postData
  );
}

export async function assignUserTaskGroups(
  userId: string,
  taskGroupIds: string[]
) {
  return dispatchClient.put<TaskGroup>(
    `${APIM_SERVICE_TASK_GROUPS_URL}/users/${userId}`,
    taskGroupIds
  );
}
